import { MenuItem, Select } from "@material-ui/core";
import { useRuleContext } from "pages/Rules/Form/context/ruleContext";
import { useTranslation } from "react-i18next";

import { Rule } from "pages/Rules/common/types";
import { getEmailFlow } from "pages/Rules/Form/context/ruleSelectors";
import { getCloudStorage as getStorage } from "pages/Rules/Form/context/ruleSelectors";

export default function SelectDirection({
  onChange,
}: {
  onChange: (bidirectional: boolean) => void;
}) {
  const { t } = useTranslation("rules");
  const { state, dispatch } = useRuleContext();
  const emailFlow = getEmailFlow(state.rule);
  if (!emailFlow) return;

  const value = emailFlow.bidirectional ? "between" : "from";

  function changeValue(event) {
    const newValue = event.target.value as "between" | "from";

    dispatch({
      type: "updateStep",
      payload: {
        step: "target",
        changes: { bidirectional: newValue === "between" },
      },
    });

    onChange(newValue === "between");
  }

  return (
    <Select
      fullWidth
      variant="outlined"
      onChange={changeValue}
      value={value}
      disabled={!canChange(state.rule)}
    >
      <MenuItem data-testid="email-flow__start-between-item" value="between">
        {t("emailFlowSection.between")}
      </MenuItem>
      <MenuItem data-testid="email-flow__start-from-item" value="from">
        {t("emailFlowSection.from")}
      </MenuItem>
    </Select>
  );
}

function canChange(rule: Rule): boolean {
  const { actionType } = rule;
  if (actionType === "SMIME_EMAILS") return true;
  if (
    actionType === "ZIP_ATTACHMENTS" ||
    actionType === "REQUEST_APPROVAL" ||
    actionType === "SEND_DELAY"
  ) {
    return false;
  }

  const storage = getStorage(rule);
  return storage?.syncAllByRule === false;
}
